import { Grid } from "@material-ui/core"
import MigaPan from '../../../../app/orussystem/component/MigaPan';
import { ROL_USER } from '../../../../app/api-client/constants';
import SimpleCard from '../../../../utils/card';
import { useHistory } from 'react-router-dom';

export default function Administracion() {
    const rol = localStorage.getItem(ROL_USER);
    const history = useHistory();

    const handledClientes = () => {
        history.push(`/Clientes`);
    }
    const handledAños = () => {
        history.push(`/Años`);
    }
    const handleAdmin = () => {
        history.push(`/Usuarios`)
    }
    const handleModulos = () => {
        history.push(`/modulosgenerales`)
    }

    return (
        <Grid container spacing={1} style={{ marginBottom: '35px', marginTop: '2%', marginLeft: 0, marginRight: 0 }}>
            <br></br>
            <br></br>

            <MigaPan
                namePage="Administracion"
                to="/"
            >
                Home
            </MigaPan>

            <Grid container spacing={2} style={{ marginBottom: '35px', marginTop: '2%', marginLeft: 0, marginRight: 0 }}>
                {rol === "ROLE_ADMIN" && (
                    <Grid item xs={12} sm={6} md={4}>
                        <SimpleCard
                            title="Clientes"
                            messageInfo="Clientes"
                            img="clientes"
                            event={handledClientes}
                        />
                    </Grid>
                )}
                {rol === "ROLE_ADMIN" && (
                    <Grid item xs={12} sm={6} md={4}>
                        <SimpleCard
                            title="Años"
                            messageInfo="Listar, crear e inactivar años"
                            img="años"
                            event={handledAños}
                        />
                    </Grid>
                )}
                {rol === "ROLE_ADMIN" && (
                    <Grid item xs={12} sm={6} md={4}>
                        <SimpleCard
                            title="Usuarios"
                            messageInfo="Administración de usuarios"
                            img="adminuser"
                            event={handleAdmin}
                        />
                    </Grid>
                )}
                    {rol === "ROLE_ADMIN" && (
                    <Grid item xs={12} sm={6} md={4}>
                        <SimpleCard
                            title="Modulos"
                            messageInfo="Administración de Modulos"
                            img="modulos"
                            event={handleModulos}
                        />
                    </Grid>
                )}
            </Grid>
        </Grid>
    )
}
